import React from 'react'

const ChangePassword = ({ changePasswordHandler, changePasswordChange, errorMsg }) => (
    <div className="popup-main">
        <div className="popup-container card advance-search-popup change-password-main">
            <div className="card-header">
                <h6>
                    <span>Change Password</span>
                    <button className="close" onClick={e => changePasswordHandler('close')}>&times;</button>
                </h6>
            </div>
            <div className="card-body">
                <div className="row form-group">
                    <div className="col-12">
                        <label className="font-12px m-0">Type your current password</label>
                        <input
                            type="password"
                            className="form-control"
                            onChange={e => changePasswordChange(e, 'oldPassword')}
                        />
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-12">
                        <label className="font-12px m-0">Type your new password</label>
                        <input
                            type="password"
                            className="form-control"
                            onChange={e => changePasswordChange(e, 'newPassword')}
                        />
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-12">
                        <label className="font-12px m-0">Retype your new password</label>
                        <input
                            type="password"
                            className="form-control"
                            onChange={e => changePasswordChange(e, 'confirmPassword')}
                        />
                    </div>
                </div>
                <p className="m-0 validation-msg">{errorMsg}</p>
            </div>
            <div className="card-footer">
                <button
                    className="kog-btn center-block"
                    onClick={e => changePasswordHandler('save')}
                >Save</button>
            </div>
        </div>
    </div>
)

export default ChangePassword;